(function () {
  'use strict';

  // All products page (concept C). ADD puts one tin in the cart; the progress bar, the cards and the sticky pill all read
  // the cart, so what they say matches the store's automatic discounts (2 tins save $8, 3 tins save $26.99, mixed OK).
  const root = document.querySelector('[data-scc]');
  if (!root) return;

  const handles = (root.dataset.handles || '').split(',').map((h) => h.trim()).filter(Boolean);
  const addUrl = (() => { const u = root.dataset.cartAddUrl || '/cart/add'; return u.endsWith('.js') ? u : u + '.js'; })();
  const d2 = Number(root.dataset.d2) || 800;
  const d3 = Number(root.dataset.d3) || 2699;
  const freeQty = Number(root.dataset.freeQty) || 3;
  const currency = root.dataset.currency || 'USD';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents) / 100);
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cartJsUrl = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js';

  const count = root.querySelector('[data-scc-count]');
  const dots = Array.from(root.querySelectorAll('[data-scc-dot]'));
  const status = root.querySelector('[data-scc-status]');
  const offer = root.querySelector('[data-scc-offer]');
  const pill = root.querySelector('[data-scc-pill]');
  const pillText = root.querySelector('[data-scc-pill-text]');
  const pillBtn = root.querySelector('[data-scc-pill-btn]');
  const slots = Array.from(root.querySelectorAll('[data-scc-slot]'));
  const addButtons = Array.from(root.querySelectorAll('[data-scc-add]'));
  const imgByHandle = {};
  addButtons.forEach((b) => { imgByHandle[b.dataset.handle] = b.dataset.img; });

  let counts = {};
  let total = 0;
  let offerVisible = true;
  let footerVisible = false;
  let scrolled = false;

  function tally(cart) {
    const next = {};
    let n = 0;
    (cart.items || []).forEach((item) => {
      if (handles.indexOf(item.handle) === -1) return;
      next[item.handle] = (next[item.handle] || 0) + item.quantity;
      n += item.quantity;
    });
    counts = next;
    total = n;
  }

  function message(n) {
    if (n <= 0) return 'Pick any 3 and save ' + money(d3) + '. Free shipping on ' + freeQty + '+ tins.';
    if (n === 1) return 'Add 2 more to save ' + money(d3) + ' and ship free.';
    if (n === 2) return 'You save ' + money(d2) + ' now. Add 1 more to save ' + money(d3) + ' and ship free.';
    if (n === 3) return 'You are saving ' + money(d3) + ' and shipping free.';
    return 'Your tins are discounted and shipping is free.';
  }

  function pillMessage(n) {
    if (n <= 0) return '0 of 3 in your cart';
    if (n >= 3) return n + ' tins · saving ' + (n === 3 ? money(d3) : '20%');
    return n + ' of 3 in your cart';
  }

  function render() {
    if (count) count.textContent = String(total);
    dots.forEach((dot, i) => dot.classList.toggle('is-on', i < total));
    if (status) status.textContent = message(total);
    root.classList.toggle('has-cart', total > 0);

    root.querySelectorAll('[data-scc-card]').forEach((card) => {
      const n = counts[card.dataset.sccCard] || 0;
      const chip = card.querySelector('[data-scc-incart]');
      if (chip) { chip.hidden = n === 0; chip.textContent = n ? 'In your cart ×' + n : ''; }
    });

    // The pill's slots show the actual tins in the cart (up to three), repeated per quantity.
    const tins = [];
    Object.keys(counts).forEach((h) => { for (let i = 0; i < counts[h] && tins.length < 3; i += 1) tins.push(h); });
    slots.forEach((slot, i) => {
      const h = tins[i];
      slot.classList.toggle('is-filled', Boolean(h));
      slot.style.backgroundImage = h && imgByHandle[h] ? 'url("' + imgByHandle[h] + '")' : '';
    });
    if (pillText) pillText.textContent = pillMessage(total);
    if (pillBtn) pillBtn.textContent = total > 0 ? 'VIEW CART' : 'SEE THE DEAL';
    updatePill();
  }

  function updatePill() {
    if (!pill) return;
    // The offer bar sits below the product cards, so the pill carries the offer while people browse the cards:
    // it shows once they scroll (or have tins in the cart), unless the bar itself or the footer is on screen.
    const visible = !offerVisible && !footerVisible && (scrolled || total > 0);
    pill.classList.toggle('is-visible', visible);
    pill.setAttribute('aria-hidden', String(!visible));
    pill.inert = !visible;
  }

  async function sync() {
    try {
      const response = await fetch(cartJsUrl(), { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      tally(await response.json());
      render();
    } catch (error) { /* the page still works without the live count */ }
  }

  async function addTin(button) {
    if (!window.FuseCartQuantity || button.getAttribute('aria-busy') === 'true') return;
    const label = button.querySelector('[data-scc-add-label]') || button;
    const original = label.textContent;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'ADDING...';
    let cart = null;
    let ok = false;
    try {
      const fd = new FormData();
      fd.append('id', button.dataset.variantId);
      fd.append('quantity', '1');
      cart = await window.FuseCartQuantity.add(addUrl, fd);
      ok = true;
    } catch (error) {
      if (error.addConfirmed) ok = true;
      else if (status) status.textContent = error.message || 'Could not add this tin. Try again.';
    }
    if (ok) {
      label.textContent = 'ADDED';
      if (cart && cart.items) { tally(cart); render(); if (window.Wisp && window.Wisp.updateCartCount) window.Wisp.updateCartCount(cart.item_count); }
      else sync();
      if (window.Wisp && window.Wisp.showToast) window.Wisp.showToast(button.dataset.name + ' added to cart');
    } else {
      label.textContent = 'TRY AGAIN';
    }
    window.setTimeout(() => { button.removeAttribute('aria-busy'); label.textContent = original; }, 1300);
  }

  addButtons.forEach((button) => button.addEventListener('click', () => addTin(button)));

  if (pillBtn) {
    pillBtn.addEventListener('click', () => {
      if (total > 0 && window.Wisp && window.Wisp.openCart) { window.Wisp.openCart(); return; }
      const target = root.querySelector('[data-scc-offer]');
      if (target) target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
    });
  }

  if (offer && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => { offerVisible = entry.isIntersecting; updatePill(); }).observe(offer);
  }
  window.addEventListener('scroll', () => { const next = window.scrollY > 240; if (next !== scrolled) { scrolled = next; updatePill(); } }, { passive: true });
  const footer = document.querySelector('.site-footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; updatePill(); }).observe(footer);
  }

  // Keep the count right when the cart changes elsewhere (drawer edits update the header count) or on back/forward.
  let syncTimer = 0;
  const queueSync = () => { window.clearTimeout(syncTimer); syncTimer = window.setTimeout(sync, 250); };
  document.querySelectorAll('[data-cart-count]').forEach((el) => new MutationObserver(queueSync).observe(el, { childList: true, characterData: true, subtree: true }));
  window.addEventListener('pageshow', (event) => { if (event.persisted) sync(); });

  render();
  sync();

  // ---------- reviews: same Judge.me rules as the PDP and home page ----------
  const reviews = root.querySelector('[data-scc-reviews]');
  if (!reviews) return;
  const rvStatus = reviews.querySelector('[data-scc-rv-status]');
  const rvList = reviews.querySelector('[data-scc-rv-list]');
  // Confirmed household reviews, checked September 7, 2026. Excluded only from these highlights.
  const excluded = new Set([
    '44b672e3-67b6-4a5e-b8a3-89706813bb08',
    'a76e9c6d-33b0-4ba7-aae0-28f624465210',
    'deb413e9-2b4d-46d8-9732-29349f4c1f5f'
  ]);
  const plain = (html) => { const el = document.createElement('div'); el.innerHTML = html || ''; return (el.textContent || '').replace(/\s+/g, ' ').trim(); };

  function renderReviews(records) {
    const picked = records
      .filter((r) => r.verified_buyer === true && !excluded.has(r.uuid))
      .map((r) => ({ author: r.reviewer_name || '', body: plain(r.body_html), rating: Math.round(Number(r.rating)) }))
      .filter((r) => r.author && r.body && r.rating >= 1 && r.rating <= 5)
      .slice(0, 2);
    if (!picked.length) { rvStatus.textContent = 'No customer reviews to display yet.'; return; }
    const cards = Array.from(reviews.querySelectorAll('[data-scc-rv-card]'));
    picked.forEach((r, i) => {
      const card = cards[i];
      if (!card) return;
      const stars = card.querySelector('[data-scc-rv-stars]');
      stars.textContent = '★'.repeat(r.rating) + '☆'.repeat(5 - r.rating);
      stars.setAttribute('aria-label', r.rating + ' out of 5 stars');
      const text = r.body.length > 170 ? r.body.slice(0, r.body.lastIndexOf(' ', 150)).replace(/[\s.,;:!?-]+$/, '') + '…' : r.body;
      card.querySelector('[data-scc-rv-text]').textContent = '“' + text + '”';
      card.querySelector('[data-scc-rv-author]').textContent = r.author;
      card.querySelector('[data-scc-rv-avatar]').textContent = r.author.trim().charAt(0).toUpperCase();
      card.hidden = false;
    });
    rvStatus.hidden = true;
    rvList.hidden = false;
  }

  async function fetchReviews() {
    const id = reviews.dataset.productId;
    let widget; let apiBase; let shop; let platform;
    for (let attempt = 0; attempt < 20; attempt += 1) {
      widget = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && window.jdgm.data.reviewWidget[id];
      apiBase = window.jdgm && window.jdgm.CDN_API_HOST;
      shop = window.Shopify && window.Shopify.shop;
      platform = window.jdgmSettings && window.jdgmSettings.platform;
      if (widget && apiBase && shop && platform) break;
      await new Promise((resolve) => window.setTimeout(resolve, 150));
    }
    if (!id || !widget || !apiBase || !shop || !platform) throw new Error('Judge.me configuration unavailable');
    const url = new URL('reviews/reviews_for_widget', apiBase);
    url.search = new URLSearchParams({ product_id: id, page: '1', per_page: '10', sort_by: widget.sort_key || 'created_at', sort_dir: 'desc', skip_other_languages: 'true', widget_theme: 'standard', ts: widget.metafield_updated_at, shop_domain: shop, platform });
    const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'omit' });
    if (!response.ok) throw new Error('Judge.me returned ' + response.status);
    const payload = await response.json();
    if (String(payload.product_external_id) !== String(id) || !Array.isArray(payload.reviews)) throw new Error('Judge.me response did not match');
    return payload.reviews.filter((r) => r && r.uuid && r.product_url && r.is_for_product_from_bundle !== true);
  }

  let started = false;
  const start = async () => {
    if (started) return;
    started = true;
    try { renderReviews(await fetchReviews()); } catch (error) { rvStatus.textContent = 'Customer reviews are temporarily unavailable.'; }
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => { if (!entries.some((e) => e.isIntersecting)) return; observer.disconnect(); start(); }, { rootMargin: '800px 0px' });
    observer.observe(reviews);
  } else start();
})();
